import React from 'react';
import PropTypes from 'prop-types';
import { Translate } from 'react-localize-redux';
import Icon, { IconSizes, IconVariants } from '../foundations/Icon';
import css from './StepCard.css';

const StepCard = ({ index, title, subtitle, icon, badge }) => (
    <div className={css.stepCard}>
        <div className={css.stepNumber}>{index}</div>
        <div className={css.stepContent}>
            <div className={css.stepHeader}>
                <span className={css.stepTitle}>
                    <Translate id={title} />
                </span>
                {badge && (
                    <span className={css.stepBadge}>
                        <Icon name={badge.icon} size={IconSizes.X_SMALL} variant={IconVariants.ACTIVE} />
                        <Translate id={badge.name} />
                    </span>
                )}
            </div>
            <div className={css.stepSubtitle}>
                <Translate id={subtitle} />
            </div>
        </div>
        {icon && <Icon name={icon} size={IconSizes.MEDIUM} variant={IconVariants.LIGHT} />}
    </div>
);

StepCard.propTypes = {
    index: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    icon: PropTypes.string,
    badge: PropTypes.shape({
        name: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
    }),
};

export default StepCard;
